import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { Product, Voucher, ProductType, PartnerCostType } from '../../models';
import { VoucherService } from '../../providers';

@Component({
    selector: 'list-voucher',
    templateUrl: './list-voucher.component.html',
    styleUrls: ['./list-voucher.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ListVoucherComponent implements OnInit {

    constructor(private voucherService: VoucherService) { }

    @Input() voucher: Voucher;
    @Input() product: Product;
    @Input() index: number;
    @Input() collapse: boolean;

    // Expose to view
    public ProductType = ProductType;
    public PartnerCostType = PartnerCostType;

    ngOnInit(): void {
    }

    public async deleteVoucher(voucher: Voucher, product: Product = null) {
        if(!voucher) return;
        let name = product ? product.title : $localize`voucher without product`;
        let ok = await confirm($localize`Really delete this '${name}' voucher??`);
        if(ok) {
            this.voucherService.deleteVoucher(voucher.key);
        }
    }

}
